import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import FormatUtils from '../common/formatUtils/FormatUtils';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import { setError } from '../common/toast/toast';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import SelectDefault from '../common/form/selectDefault';
import DateFormat from '../common/dateFormat/DateFormat';
import ColorUtils from '../common/colorUtils/ColorUtils';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import LabelAndInputDateResumido from '../common/form/labelAndInputDateResumido';
import ButtonTable from '../common/table/buttonTable';
import consts from '../consts';
import ReactExport from 'react-export-excel-fixed-xlsx';

import {
	setModoTela, initForm, setFiltro, finalizar,
	getListaMotorista, getListaPlaca,
	getListaGestaoMotorista, salvarGestaoMotorista,
	getListaGestaoVeiculo, salvarGestaoVeiculo,
	alterrarMotoristaVencimento, getListaMotoristaVencimento
} from './gestaoVMActions';
import {
	getLista as getListaGestaoComentarioTipo
} from '../gestaoVMComentarioTipo/gestaoVMComentarioTipoActions';
import {
	getLista as getListaGestaoComentario
} from '../gestaoVMComentario/gestaoVMComentarioActions';
import { 
	getLista as getListaGrupo, alterarValidaVencimentos
} from '../gestaoVMGrupo/gestaoVMGrupoActions';
import {
	buscarPermissao
} from '../auth/authActions';
import ReactSelect from 'react-select';
import SelectResumido from '../common/form/selectResumido';
import GestaoVMComentario from '../gestaoVMComentario/gestaoVMComentario';
import { 
	getLista as getListaMotoristaGrupo
} from '../motoristaGrupo/motoristaGrupoActions';

class GestaoVMForm extends Component {

	state = {
		windowHeight: window.innerHeight,
		windowWidth: window.innerWidth,
		ordenacao: [],
		veiculosParadosLocais: [],
		gruposExpandidos: []
	}

	async componentDidMount() {

		this.permissaoTela = await this.props.buscarPermissao('/gestaoVM');
		this.permissaoAlteraTodos = this.permissaoTela && this.permissaoTela.permissoes.filter(item => item.id == 16 && item.liberado).length > 0;
		this.permissaoAlteraAbertos = this.permissaoTela && this.permissaoTela.permissoes.filter(item => item.id == 15 && item.liberado).length > 0;
				
		this.props.getListaMotorista();
		this.props.getListaPlaca();
		this.props.getListaGestaoMotorista(this.props.formularioValues.data_gestao);
		this.props.getListaGestaoVeiculo(this.props.formularioValues.data_gestao);
		this.props.getListaGestaoComentario(this.props.formularioValues.data_gestao);
		this.props.getListaMotoristaVencimento(this.props.formularioValues.data_gestao);
		this.props.getListaGestaoComentarioTipo();
		this.props.getListaMotoristaGrupo();

		this.idInterval = setInterval(() => {
			this.props.getListaMotorista();
			this.props.getListaPlaca();
			this.props.getListaGestaoMotorista(this.props.formularioValues.data_gestao);
			this.props.getListaGestaoVeiculo(this.props.formularioValues.data_gestao);
			this.props.getListaGestaoComentario(this.props.formularioValues.data_gestao);
			this.props.getListaMotoristaVencimento(this.props.formularioValues.data_gestao);
			this.props.getListaGestaoComentarioTipo();
			this.props.getListaGrupo();
			this.props.getListaMotoristaGrupo();
		}, 60000);

		document.addEventListener('keydown', this.handleKeyDown);

		window.addEventListener('resize', this.updateTela);
	}

	componentWillUnmount() {
		clearInterval(this.idInterval);

		document.removeEventListener('keydown', this.handleKeyDown);

		window.removeEventListener('resize', this.updateTela);
	}

	updateTela = () => {

		const height = window.visualViewport ? window.visualViewport.height : window.innerHeight;
		const width = window.visualViewport ? window.visualViewport.width : window.innerWidth;

		this.setState({ windowHeight: height, windowWidth: width });

	}

	handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			this.setState({
				linhaSelecionada: null,
				linhaMotoristaSelecionada: null,
				linhaSelecionadaVeiculoNaoAlocado: null,
				linhaSelecionadaMotoristaNaoAlocado: null,
				registroComentario: null
			});
		}
	};

	setOrdenacao(idGrupo, coluna) {

		let ordenacaoAux = this.state.ordenacao.map(item => ({ ...item }));
		if (!ordenacaoAux.filter(item => item.id_grupo == idGrupo && item.coluna == coluna).length) {
			ordenacaoAux.push({
				id_grupo: idGrupo,
				coluna: coluna,
				ordem: 0
			});
		}
		this.setState({
			ordenacao: ordenacaoAux.map(item => {
				if (item.id_grupo == idGrupo) {
					if (item.coluna == coluna) {
						return {
							...item,
							ordem: item.ordem == 2 ? 0 : (item.ordem || 0) + 1
						};
					} else {
						return {
							...item,
							ordem: 0
						};
					}
				} else {
					return {
						...item
					};
				}
			})
		});
	}

	getIconeOrdenacao(idGrupo, coluna) {
		const ordem = (this.state.ordenacao.filter(item => item.id_grupo == idGrupo && item.coluna == coluna)[0] || {}).ordem || 0;

		if (ordem == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (ordem == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	getOrdenacao(idGrupo, coluna) {
		const ordem = (this.state.ordenacao.filter(item => item.id_grupo == idGrupo && item.coluna == coluna)[0] || {}).ordem || 0;

		return ordem;
	}

	ordenar(idGrupo, coluna, valorA, valorB) {
		const ordem = (this.state.ordenacao.filter(item => item.id_grupo == idGrupo && item.coluna == coluna)[0] || {}).ordem || 0;
		
		return ordem == 1 
			? ((valorA || '') > (valorB || '') ? 1 : -1) 
			: ((valorA || '') > (valorB || '') ? -1 : 1)
	}

	render() {

		let readOnly = this.permissaoAlteraTodos || (this.permissaoAlteraAbertos && !this.props.formularioValues.fechada) ? '' : 'readOnly';	

		const possuiFiltro = this.props.filtro.id_motorista 
			|| this.props.filtro.cavalo 
			|| this.props.filtro.carreta 
			|| this.props.filtro.id_grupo
			|| this.props.filtro.id_motorista_grupo
			|| this.props.filtro.id_operacao;

		const listaGestaoVeiculo = this.props.listaGestaoVeiculo.map(item => {
			const cavalo = this.props.listaCavalo.filter(cavalo => cavalo.id == item.cavalo)[0];
			const carreta1 = this.props.listaCarreta.filter(carreta => carreta.id == item.carreta)[0];
			const carreta2 = this.props.listaCarreta.filter(carreta => carreta.id == item.carreta)[0];

			return {
				...item,
				cavalo_descricao: cavalo ? `${cavalo.nome_marca} | ${cavalo.nome_modelo}` : '',
				identificador: carreta1 ? carreta1.identificador : (carreta2 ? carreta2.identificador : null)
			};
		}).filter(item => {
			if (this.props.filtro.cavalo && item.cavalo != this.props.filtro.cavalo) {
				return false;
			} else if (this.props.filtro.carreta && item.carreta1 != this.props.filtro.carreta && item.carreta2 != this.props.filtro.carreta) {
				return false;
			} else if (this.props.filtro.id_motorista && item.id_motorista != this.props.filtro.id_motorista) {
				return false;
			} else if (this.props.filtro.id_motorista_grupo && item.id_motorista_grupo != this.props.filtro.id_motorista_grupo) {
				return false;
			} else if (this.props.filtro.id_operacao && item.id_operacao != this.props.filtro.id_operacao) {
				return false;
			} else if (this.props.filtro.id_comentario_tipo &&				
				!this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == item.id_motorista && comentario.id_tipo == this.props.filtro.id_comentario_tipo).length) {
				return false;
			}

			return true;
		});

		const listaGestaoMotorista = this.props.listaGestaoMotorista.map(item => {
			return {
				...item
			};
		}).filter(item => {
			if (this.props.filtro.cavalo) {
				return false;
			} else if (this.props.filtro.carreta) {
				return false;
			} else if (this.props.filtro.id_motorista && item.id_motorista != this.props.filtro.id_motorista) {
				return false;
			} else if (this.props.filtro.id_motorista_grupo && item.id_motorista_grupo != this.props.filtro.id_motorista_grupo) {
				return false;
			} else if (this.props.filtro.id_operacao && item.id_operacao != this.props.filtro.id_operacao) {
				return false;
			} else if (this.props.filtro.id_comentario_tipo &&				
				!this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == item.id_motorista && comentario.id_tipo == this.props.filtro.id_comentario_tipo).length) {
				return false;
			}			

			return true;
		});

		const listaMotoristaNaoAlocado = this.props.listaMotorista.filter(item => {
			if (this.props.listaGestaoMotorista.filter(itemMotorista => itemMotorista.id_motorista == item.id).length
		 		|| this.props.listaGestaoVeiculo.filter(itemVeiculo => itemVeiculo.id_motorista == item.id).length) {
				return false;
			} else if (this.props.filtro.cavalo && item.id != this.props.filtro.cavalo) {
				return false;
			} else if (this.props.filtro.carreta) {
				return false;
			} else if (this.props.filtro.id_motorista_grupo && item.id_motorista_grupo != this.props.filtro.id_motorista_grupo) {
				return false;
			} else if (this.props.filtro.id_motorista && item.id != this.props.filtro.id_motorista) {
				return false;
			} else if (this.props.filtro.id_operacao) {
				return false;
			}

			return true;
		});

		let quantidadeOperacaoVeiculoTotal = 0;
		let listaOperacaoVeiculo = this.props.listaOperacao.filter(item => item.veiculo).map(item => {
			quantidadeOperacaoVeiculoTotal += listaGestaoVeiculo.filter(itemGestao => itemGestao.id_operacao == item.id && itemGestao.cavalo).length;
			return {
				id_operacao: item.id,
				nome_operacao: item.valor,
				quantidade: listaGestaoVeiculo.filter(itemGestao => itemGestao.id_operacao == item.id && itemGestao.cavalo).length
			};
		});

		listaOperacaoVeiculo.sort((a, b) => b.quantidade - a.quantidade);

		let quantidadeOperacaoMotoristaTotal = 0;
		let listaOperacaoMotorista = this.props.listaOperacao.filter(item => item.motorista).map(item => {
			quantidadeOperacaoMotoristaTotal += listaGestaoVeiculo.filter(itemGestao => itemGestao.id_operacao == item.id && itemGestao.id_motorista).length
				+ listaGestaoMotorista.filter(itemGestao => itemGestao.id_operacao == item.id && itemGestao.id_motorista).length;
			return {
				id_operacao: item.id,
				nome_operacao: item.valor,
				quantidade: listaGestaoVeiculo.filter(itemGestao => itemGestao.id_operacao == item.id && itemGestao.id_motorista).length
					+ listaGestaoMotorista.filter(itemGestao => itemGestao.id_operacao == item.id && itemGestao.id_motorista).length
			};
		});
		listaOperacaoMotorista.push({
			id_operacao: 999999,
			nome_operacao: 'Não alocados',
			quantidade: listaMotoristaNaoAlocado.length
		});

		listaOperacaoMotorista.sort((a, b) => b.quantidade - a.quantidade);

		quantidadeOperacaoMotoristaTotal += listaMotoristaNaoAlocado.length;

		return (
			<div style={{ height: this.state.windowHeight - 64, overflowY: 'auto', overflowX: 'hidden' }}>
				{this.modalComentario()}

				{this.modalVencimentoMotorista()}

				<ContentCard
					style={this.state.windowWidth >= 1089 ? {
						position: 'sticky',
						top: 0,
						zIndex: 1000,
						background: '#fff',
						boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
					} : {}}>
					<ContentCardBody>
						<Row>
							<Select
								name='id_motorista'
								component={Select}
								options={this.props.listaMotorista}
								label='Motorista'
								maxWidth={350}
								minWidth={350}
								cols='12 12 4 4'
								placeholder='Selecione'
								value={this.props.filtro.id_motorista}
								onChange={value => {
									this.props.setFiltro({
										...this.props.filtro,
										id_motorista: value
									})
								}} />

							<Select
								name='cavalo'
								component={Select}
								options={this.props.listaCavalo.map(item => ({ id: item.placa, valor: item.placa }))}
								label='Cavalo'
								maxWidth={180}
								minWidth={180}
								cols='12 12 4 4'
								placeholder='Selecione'
								value={this.props.filtro.cavalo}
								onChange={value => {
									this.props.setFiltro({
										...this.props.filtro,
										cavalo: value
									})
								}} />

							<Select
								name='carreta'
								component={Select}
								options={this.props.listaCarreta.map(item => ({ id: item.placa, valor: item.placa }))}
								label='Carreta'
								maxWidth={180}
								minWidth={180}
								cols='12 12 4 4'
								placeholder='Selecione'
								value={this.props.filtro.carreta}
								onChange={value => {
									this.props.setFiltro({
										...this.props.filtro,
										carreta: value
									})
								}} />

							<Select
								name='id_grupo'
								component={Select}
								options={this.props.listaGrupo}
								label='Grupo de Veículo'
								maxWidth={300}
								minWidth={300}
								cols='12 12 4 4'
								placeholder='Selecione'
								value={this.props.filtro.id_grupo}
								onChange={value => {
									this.props.setFiltro({
										...this.props.filtro,
										id_grupo: value
									})
								}} />

							<Select
								name='id_grupo'
								component={Select}
								options={this.props.listaMotoristaGrupo}
								label='Grupo de Motorista'
								maxWidth={300}
								minWidth={300}
								cols='12 12 4 4'
								placeholder='Selecione'
								value={this.props.filtro.id_motorista_grupo}
								onChange={value => {
									this.props.setFiltro({
										...this.props.filtro,
										id_motorista_grupo: value
									})
								}} />

							<Select
								name='id_operacao'
								component={Select}
								options={this.props.listaOperacao}
								label='Operação'
								maxWidth={300}
								minWidth={300}
								cols='12 12 4 4'
								placeholder='Selecione'
								value={this.props.filtro.id_operacao}
								onChange={value => {
									this.props.setFiltro({
										...this.props.filtro,
										id_operacao: value
									})
								}} />

							<Select
								name='id_comentario_tipo'
								component={Select}
								options={this.props.listaComentarioTipo}
								label='Comentário'
								maxWidth={300}
								minWidth={300}
								cols='12 12 4 4'
								placeholder='Selecione'
								value={this.props.filtro.id_comentario_tipo}
								onChange={value => {
									this.props.setFiltro({
										...this.props.filtro,
										id_comentario_tipo: value
									})
								}} />

							<div style={{ width: 240, marginTop: 8, marginLeft: 8 }}>
								<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
									onClick={() => {
										this.props.getListaGestaoMotorista(this.props.formularioValues.data_gestao);
										this.props.getListaGestaoVeiculo(this.props.formularioValues.data_gestao);
										this.props.getListaGestaoComentario(this.props.formularioValues.data_gestao);
										this.props.getListaMotoristaVencimento(this.props.formularioValues.data_gestao);
									}}>
									<i class='fas fa-sync-alt'></i> Atualizar
								</a>

								<a class='btn btn-app bg-secondary'
									style={{ marginLeft: 2, minWidth: 75 }}
									title={!this.state.gruposExpandidos.length ? 'Expandir todos' : 'Recolher todos'}
									onClick={() => {
										this.setState({ gruposExpandidos: this.state.gruposExpandidos.length ? [] : this.props.listaGrupo.map(item => item.id) });
									}}>
									<i class={!this.state.gruposExpandidos.length ? 'fas fa-chevron-down' : 'fas fa-chevron-up'}></i> Todos
								</a>

								<a class='btn btn-app bg-warning' style={{ marginLeft: 2, minWidth: 75 }}
									onClick={() => {
										this.props.setModoTela('lista')
									}}>
									<i class='fas fa-arrow-left'></i> Voltar
								</a>
							</div>
						</Row>
					</ContentCardBody>
				</ContentCard>

				<Row>
					<Grid cols='12 6 6 6'>
						<ContentCard style={{ marginTop: 8 }}>
							<ContentCardHeader style={{ paddingBottom: 8 }}>
								<p style={{ padding: 0, margin: 0, textAlign: 'center', fontSize: 20 }}>
									<strong>Veículos</strong>
								</p>
							</ContentCardHeader>
							<ContentCardBody>
								<div class='progress-group' style={{ fontSize: 16, fontWeight: 'bold' }}>
									Total
									<span class='float-right'><b>{quantidadeOperacaoVeiculoTotal}</b></span>
									<div class='progress progress-sm'>
										<div class='progress-bar bg-secondary'
											style={{ width: '100%' }}>
										</div>
									</div>
								</div>
								{listaOperacaoVeiculo.map(item => (
									<div key={item.id_operacao} class='progress-group'>
										{item.nome_operacao}
										<span class='float-right'><b>{item.quantidade}</b></span>
										<div class='progress progress-sm'>
											<div class='progress-bar bg-secondary'
												style={{ width: `${quantidadeOperacaoVeiculoTotal > 0 ? (item.quantidade * 100) / quantidadeOperacaoVeiculoTotal : 0}%` }}>
											</div>
										</div>
									</div>
								))}
							</ContentCardBody>
						</ContentCard>
					</Grid>
					<Grid cols='12 6 6 6'>
						<ContentCard style={{ marginTop: 8 }}>
							<ContentCardHeader style={{ paddingBottom: 8 }}>
								<p style={{ padding: 0, margin: 0, textAlign: 'center', fontSize: 20 }}>
									<strong>Motoristas</strong>
								</p>
							</ContentCardHeader>
							<ContentCardBody>
								<div class='progress-group' style={{ fontSize: 16, fontWeight: 'bold' }}>
									Total
									<span class='float-right'><b>{quantidadeOperacaoMotoristaTotal}</b></span>
									<div class='progress progress-sm'>
										<div class='progress-bar bg-secondary'
											style={{ width: '100%' }}>
										</div>
									</div>
								</div>
								{listaOperacaoMotorista.map(item => (
									<div key={item.id_operacao} class='progress-group'>
										{item.nome_operacao}
										<span class='float-right'><b>{item.quantidade}</b></span>
										<div class='progress progress-sm'>
											<div class='progress-bar bg-secondary'
												style={{ width: `${quantidadeOperacaoMotoristaTotal > 0 ? (item.quantidade * 100) / quantidadeOperacaoMotoristaTotal : 0}%` }}>
											</div>
										</div>
									</div>
								))}
							</ContentCardBody>
						</ContentCard>
					</Grid>
				</Row>

				{this.props.listaGrupo.filter(item => {
					if (this.props.filtro.id_grupo && item.id != this.props.filtro.id_grupo) {
						return false;
					}
					return true;
				}).map((grupo, i) => {
					/*
						Tipos:
							1 - Veículos
							2 - Veículos Parados
							3 - Motoristas
							4 - Motoristas não Alocados 
							5 - Veículos não Alocados
					*/
					if (grupo.id_tipo == 1 && (!possuiFiltro || listaGestaoVeiculo.filter(item => item.id_grupo == grupo.id).length)) {
						return this.montarGrupoVeiculoViagem(grupo, i + 1, listaGestaoVeiculo.filter(item => item.id_grupo == grupo.id).map(item => ({ ...item })), readOnly);
					} else if (grupo.id_tipo == 2 && (!possuiFiltro || listaGestaoVeiculo.filter(item => item.id_grupo == grupo.id).length)) {
						return this.montarGrupoVeiculoParado(grupo, i + 1, listaGestaoVeiculo.filter(item => item.id_grupo == grupo.id).map(item => ({ ...item })), readOnly);
					} else if (grupo.id_tipo == 3 && (!possuiFiltro || listaGestaoMotorista.filter(item => item.id_grupo == grupo.id).length)) {
						return this.montarGrupoMotorista(grupo, i + 1, listaGestaoMotorista.filter(item => item.id_grupo == grupo.id).map(item => ({ ...item })), readOnly);
					} else if (grupo.id_tipo == 4 && (!possuiFiltro || listaMotoristaNaoAlocado.length)) {
						return this.montarGrupoMotoristaNaoAlocado(grupo, i + 1, listaMotoristaNaoAlocado.map(item => ({ ...item })), readOnly);
					} else if (grupo.id_tipo == 5 && (!possuiFiltro || listaGestaoMotorista.filter(item => item.id_grupo == grupo.id).length)) {
						return this.montarGrupoVeiculoNaoAlocado(grupo, i + 1, listaGestaoVeiculo.filter(item => item.id_grupo == grupo.id).map(item => ({ ...item })), readOnly);
					} else {
						console.log(grupo);
						
						return null;  //this.montarGrupo(grupo, i + 1, readOnly);
					}
				})}
			</div>
		);
	}

	setGrupoExpandido(id) {
		this.setState(prev => {
			const expanded = new Set(prev.gruposExpandidos);

			if (expanded.has(id)) {
				expanded.delete(id);
			} else {
				expanded.add(id);
			}

			return { gruposExpandidos: [...expanded] };
		});
	}

	montarGrupoVeiculoViagem(grupo, posicao, listaGestaoVeiculo, readOnly) {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		if (this.getOrdenacao(grupo.id, 'cavalo')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'cavalo', a.cavalo, b.cavalo));
		} else if (this.getOrdenacao(grupo.id, 'modelo')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'modelo', a.cavalo_descricao, b.cavalo_descricao));
		} else if (this.getOrdenacao(grupo.id, 'carreta1')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'carreta1', a.carreta1, b.carreta1));
		} else if (this.getOrdenacao(grupo.id, 'carreta2')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'carreta2', a.carreta2, b.carreta2));
		} else if (this.getOrdenacao(grupo.id, 'identificador')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'identificador', a.identificador, b.identificador));
		} else if (this.getOrdenacao(grupo.id, 'motorista')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'motorista', a.nome_motorista, b.nome_motorista));
		} else if (this.getOrdenacao(grupo.id, 'comentario')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'comentario', 
				this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == a.id_motorista).length, 
				this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == b.id_motorista).length
			));
		} else if (this.getOrdenacao(grupo.id, 'documento_vencimento')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'documento_vencimento', 
				this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == a.id_motorista && vencimento.alerta).length,
				this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == b.id_motorista && vencimento.alerta).length
			));
		} else if (this.getOrdenacao(grupo.id, 'operacao')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'operacao', a.nome_operacao, b.nome_operacao));
		}

		return (
			<ContentCard style={{ marginTop: 8 }} colapsedCard={!this.state.gruposExpandidos.includes(grupo.id)}>
				<ContentCardHeader>
					<h3 class='card-title' style={{ marginTop: 6 }}>{posicao} - {grupo.valor}</h3>
					<div class='card-tools' style={{ display: 'flex', alignItems: 'center' }}>
						<span title='Registros' 
							class='badge badge-dark'
							style={{
								paddingLeft: 8,
								paddingTop: 4,
								paddingRight: 8,
								paddingBottom: 4,
								fontSize: 14,
								fontWeight: 'normal'
							}}>{listaGestaoVeiculo.length}</span>

						<button type='button'
							class='btn btn-secondary btn-sm'
							data-card-widget='collapse'
							onClick={() => {
								this.setGrupoExpandido(grupo.id);
							}}>
							<i class={!this.state.gruposExpandidos.includes(grupo.id) ? 'fas fa-chevron-down' : 'fas fa-chevron-up'}></i>
						</button>

						<ExcelFile
							filename={`${posicao} - ${grupo.valor}`}
							element={
								<button type='button' class='btn btn-success btn-sm' title='Exportar'>
									<i class='fas fa-file-excel'></i>
								</button>
							}>
							<ExcelSheet data={listaGestaoVeiculo.map((item, i) => ({
								...item,
								ordem: i+1,
								comentarios: this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == item.id_motorista).length,
								alerta_documento: this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == item.id_motorista && vencimento.alerta).length > 0 ? 'SIM' : 'NÃO'
							}))} name={`${posicao} - ${grupo.valor}`}>
								<ExcelColumn label='Ordem' value='ordem' />
								<ExcelColumn label='Cavalo' value='cavalo' />
								<ExcelColumn label='Modelo' value='cavalo_descricao' />
								<ExcelColumn label='Semi - Reboques 1' value='carreta1' />
								<ExcelColumn label='Semi - Reboques 2' value='carreta2' />
								<ExcelColumn label='Identificador' value='identificador' />
								<ExcelColumn label='Motorista' value='nome_motorista' />
								<ExcelColumn label='Comentário' value='comentarios' />
								<ExcelColumn label='Documentos e Vencimentos' value='alerta_vencimento' />
								<ExcelColumn label='Operação' value='nome_operacao' />
							</ExcelSheet>
						</ExcelFile>
					</div>
				</ContentCardHeader>
				<div className={`card-body gestao-vm-box ${this.state.gruposExpandidos.includes(grupo.id) ? 'open' : ''}`} style={{ paddingRight: 0, paddingBottom: 0, paddingLeft: 0, paddingTop: 0 }}>
					<Table responsive border striped>
						<THead>
							<Tr backgroundColor={'#1F3066'} color={'#ffffff'}>
								<Th width={1} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter></Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'cavalo')}>Cavalo {this.getIconeOrdenacao(grupo.id, 'cavalo')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'modelo')}>Modelo {this.getIconeOrdenacao(grupo.id, 'modelo')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'carreta1')}>Semi - Reboques 1 {this.getIconeOrdenacao(grupo.id, 'carreta1')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'carreta2')}>Semi - Reboques 2 {this.getIconeOrdenacao(grupo.id, 'carreta2')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'identificador')}>Identificador {this.getIconeOrdenacao(grupo.id, 'identificador')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'motorista')}>Motorista {this.getIconeOrdenacao(grupo.id, 'motorista')}</Th>
								<Th width={1} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Comentário'
									onClick={() => this.setOrdenacao(grupo.id, 'comentario')}>
									<i class='fas fa-comments'></i> {this.getIconeOrdenacao(grupo.id, 'comentario')}
								</Th>
								<Th width={1} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Documentos e Vencimentos'
									onClick={() => this.setOrdenacao(grupo.id, 'documento_vencimento')}>
									<i class='fas fa-calendar-alt'></i> {this.getIconeOrdenacao(grupo.id, 'documento_vencimento')}
								</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'operacao')}>Operação {this.getIconeOrdenacao(grupo.id, 'operacao')}</Th>
							</Tr>
						</THead>
						<TBody>
							{listaGestaoVeiculo.map((item, i) => {

								if (this.state.linhaSelecionada == item.id && !readOnly) {
									return (
										<Tr key={item.id}
											backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')} >
											<Td color={'#000'} alignCenter small>{i+1}</Td>
											<Td color={'#000'} alignCenter small>{item.cavalo}</Td>
											<Td color={'#000'} alignCenter small>{item.cavalo_descricao}</Td>
											<Td color={'#000'} alignCenter small>{item.carreta1}</Td>
											<Td color={'#000'} alignCenter small>{item.carreta2}</Td>
											<Td color={'#000'} alignCenter small>{item.identificador}</Td>
											<Td color={'#000'} alignCenter small title='Motorista'>
												<SelectResumido
													value={item.id_motorista}
													onChange={value => {
														this.props.salvarGestaoVeiculo({
															...item,
															id_motorista: value
														});
													}}
													options={this.props.listaMotorista} />
											</Td>
											<Td color={'#000'} alignCenter small title='Comentário'>
												<button type='button' 
													class='btn btn-secondary'
													style={{
														width: 24,
														height: 24,
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														padding: 0
													}}
													disabled={!item.id_motorista}
													onClick={() => {
														if (item.id_motorista) {
															this.setState({
																registroComentario: {
																	id_motorista: item.id_motorista,
																	nome_motorista: item.nome_motorista
																}
															});
														}
													}}>{this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == item.id_motorista).length}</button>
											</Td>
											<Td color={'#000'} alignCenter small title='Documentos e Vencimentos'>
												<button type='button' 
													class='btn btn-secondary'
													style={{
														width: 24,
														height: 24,
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														padding: 0,
														backgroundColor: this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == item.id_motorista && vencimento.alerta).length > 0 ? '#ff2a00' : null
													}}
													disabled={!item.id_motorista}
													onClick={() => {
														if (item.id_motorista) {
															this.setState({
																registroVencimentoMotorista: {
																	id_motorista: item.id_motorista,
																	nome_motorista: item.nome_motorista,
																	grupo: grupo
																}
															});
														}
													}}>
													{this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == item.id_motorista && vencimento.alerta).length > 0 ? (
														<i class='fas fa-exclamation-triangle'></i>
													) : (
														<i class='fas fa-check'></i>
													)}
												</button>
											</Td>
											<Td color={'#000'} alignCenter small title='Operação'>
												<SelectResumido
													value={item.id_operacao}
													onChange={value => {
														this.props.salvarGestaoVeiculo({
															...item,
															id_operacao: value
														});
													}}
													options={this.props.listaOperacao} />
											</Td>
										</Tr>
									);
								} else {
									return (
										<Tr key={item.id}
											backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
											onClick={() => this.setState({ linhaSelecionada: item.id })} >
											<Td color={'#000'} alignCenter small>{i+1}</Td>
											<Td color={'#000'} alignCenter small>{item.cavalo}</Td>
											<Td color={'#000'} alignCenter small>{item.cavalo_descricao}</Td>
											<Td color={'#000'} alignCenter small>{item.carreta1}</Td>
											<Td color={'#000'} alignCenter small>{item.carreta2}</Td>
											<Td color={'#000'} alignCenter small>{item.identificador}</Td>
											<Td color={'#000'} alignCenter small>{item.nome_motorista}</Td>
											<Td color={'#000'} alignCenter small title='Comentário'>
												<button type='button' 
													class='btn btn-secondary'
													style={{
														width: 24,
														height: 24,
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														padding: 0
													}}
													disabled={!item.id_motorista}
													onClick={() => {
														if (item.id_motorista) {
															this.setState({
																registroComentario: {
																	id_motorista: item.id_motorista,
																	nome_motorista: item.nome_motorista
																}
															});
														}
													}}>{this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == item.id_motorista).length}</button>
											</Td>
											<Td color={'#000'} alignCenter small title='Documentos e Vencimentos'>
												<button type='button' 
													class='btn btn-secondary'
													style={{
														width: 24,
														height: 24,
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														padding: 0,
														backgroundColor: this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == item.id_motorista && vencimento.alerta).length > 0 ? '#ff2a00' : null
													}}
													disabled={!item.id_motorista}
													onClick={() => {
														if (item.id_motorista) {
															this.setState({
																registroVencimentoMotorista: {
																	id_motorista: item.id_motorista,
																	nome_motorista: item.nome_motorista,
																	grupo: grupo
																}
															});
														}
													}}>
													{this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == item.id_motorista && vencimento.alerta).length > 0 ? (
														<i class='fas fa-exclamation-triangle'></i>
													) : (
														<i class='fas fa-check'></i>	
													)}
												</button>
											</Td>
											<Td color={'#000'} alignCenter small>{item.nome_operacao}</Td>
										</Tr>
									);}
							})}
							{/*!readOnly &&
							<Tr backgroundColor={'#f5f5f5'} >
								<Td color={'#000'} alignCenter small bold>+</Td>
								<Td color={'#000'} alignCenter small title='Cavalo'>
									<ReactSelect
										isClearable={false}
										isSearchable={true}
										value={this.state.cavaloSelect}
										onChange={item => {
											this.props.salvarGestaoVeiculo({
												data_gestao: this.props.formularioValues.data_gestao,
												id_grupo: grupo.id,
												cavalo: item.value,
												carreta1: null,
												carreta2: null,
												id_motorista: null,
												id_operacao: null
											});
											this.setState({
												cavaloSelect: 0
											})
										}}
										options={this.props.listaCavalo.map(opt => ({ value: opt.id, label: opt.valor }))}
										menuPortalTarget={document.body}
										styles={{
											menuPortal: base => ({ ...base, zIndex: 9999 }),
										}} />
								</Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
							</Tr>*/}
						</TBody>
					</Table>
				</div>
			</ContentCard>
		);
	}

	montarGrupoVeiculoParado(grupo, posicao, listaGestaoVeiculo, readOnly) {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		if (this.getOrdenacao(grupo.id, 'cavalo')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'cavalo', a.cavalo, b.cavalo));
		} else if (this.getOrdenacao(grupo.id, 'modelo')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'modelo', a.cavalo_descricao, b.cavalo_descricao));
		} else if (this.getOrdenacao(grupo.id, 'carreta1')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'carreta1', a.carreta1, b.carreta1));
		} else if (this.getOrdenacao(grupo.id, 'carreta2')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'carreta2', a.carreta2, b.carreta2));
		} else if (this.getOrdenacao(grupo.id, 'inicio')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'inicio', a.data_parada, b.data_parada));
		} else if (this.getOrdenacao(grupo.id, 'dias')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'dias', a.dias_parado, b.dias_parado));
		} else if (this.getOrdenacao(grupo.id, 'identificador')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'identificador', a.identificador, b.identificador));
		} else if (this.getOrdenacao(grupo.id, 'motorista')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'motorista', a.nome_motorista, b.nome_motorista));
		} else if (this.getOrdenacao(grupo.id, 'comentario')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'comentario', 
				this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == a.id_motorista).length, 
				this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == b.id_motorista).length
			));
		} else if (this.getOrdenacao(grupo.id, 'documento_vencimento')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'documento_vencimento', 
				this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == a.id_motorista && vencimento.alerta).length,
				this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == b.id_motorista && vencimento.alerta).length
			));
		} else if (this.getOrdenacao(grupo.id, 'local')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'local', a.observacao_parada, b.observacao_parada));
		} else if (this.getOrdenacao(grupo.id, 'operacao')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'operacao', a.nome_operacao, b.nome_operacao));
		}

		return (
			<ContentCard style={{ marginTop: 8 }} colapsedCard={!this.state.gruposExpandidos.includes(grupo.id)}>
				<ContentCardHeader style={{ paddingBottom: 8 }}>
					<h3 class='card-title' style={{ marginTop: 6 }}>{posicao} - {grupo.valor}</h3>
					<div class='card-tools' style={{ display: 'flex', alignItems: 'center' }}>
						<span title='Registros' 
							class='badge badge-dark'
							style={{
								paddingLeft: 8,
								paddingTop: 4,
								paddingRight: 8,
								paddingBottom: 4,
								fontSize: 14,
								fontWeight: 'normal'
							}}>{listaGestaoVeiculo.length}</span>
						<button type='button'
							class='btn btn-secondary btn-sm'
							data-card-widget='collapse'
							onClick={() => {
								this.setGrupoExpandido(grupo.id);
							}}>
							<i class={!this.state.gruposExpandidos.includes(grupo.id) ? 'fas fa-chevron-down' : 'fas fa-chevron-up'}></i>
						</button>
						<ExcelFile
							filename={`${posicao} - ${grupo.valor}`}
							element={
								<button type='button' class='btn btn-success btn-sm' title='Exportar'>
									<i class='fas fa-file-excel'></i>
								</button>
							}>
							<ExcelSheet data={listaGestaoVeiculo.map((item, i) => ({
								...item,
								ordem: i+1,
								data_parada: DateFormat.formatarDataSqlParaTela(item.data_parada)
							}))} name={`${posicao} - ${grupo.valor}`}>
								<ExcelColumn label='Ordem' value='ordem' />
								<ExcelColumn label='Cavalo' value='cavalo' />
								<ExcelColumn label='Modelo' value='cavalo_descricao' />
								<ExcelColumn label='Semi - Reboques 1' value='carreta1' />
								<ExcelColumn label='Semi - Reboques 2' value='carreta2' />
								<ExcelColumn label='Início' value='data_parada' />
								<ExcelColumn label='Dias' value='dias_parado' />
								<ExcelColumn label='Identificador' value='identificador' />
								<ExcelColumn label='Local' value='observacao_parada' />
								<ExcelColumn label='Operação' value='nome_operacao' />
							</ExcelSheet>
						</ExcelFile>
					</div>
				</ContentCardHeader>
				<div className={`card-body gestao-vm-box ${this.state.gruposExpandidos.includes(grupo.id) ? 'open': ''}`} style={{ paddingRight: 0, paddingBottom: 0, paddingLeft: 0, paddingTop: 0 }}>
					<Table responsive border striped>
						<THead>
							<Tr backgroundColor={'#1F3066'} color={'#ffffff'}>
								<Th width={1} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter></Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'cavalo')}>Cavalo {this.getIconeOrdenacao(grupo.id, 'cavalo')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'modelo')}>Modelo {this.getIconeOrdenacao(grupo.id, 'modelo')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'carreta1')}>Semi - Reboques 1 {this.getIconeOrdenacao(grupo.id, 'carreta1')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'carreta2')}>Semi - Reboques 2 {this.getIconeOrdenacao(grupo.id, 'carreta2')}</Th>
								<Th width={90} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter 
									onClick={() => this.setOrdenacao(grupo.id, 'inicio')}>Início  {this.getIconeOrdenacao(grupo.id, 'inicio')}</Th>
								<Th width={50} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter 
									onClick={() => this.setOrdenacao(grupo.id, 'dias')}>Dias {this.getIconeOrdenacao(grupo.id, 'dias')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'identificador')}>Identificador {this.getIconeOrdenacao(grupo.id, 'identificador')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'local')}>Local {this.getIconeOrdenacao(grupo.id, 'local')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'operacao')}>Operação {this.getIconeOrdenacao(grupo.id, 'operacao')}</Th>
							</Tr>
						</THead>
						<TBody>
							{listaGestaoVeiculo.map((item, i) => {
								if (this.state.linhaSelecionada == item.id && !readOnly) {
									return (
										<Tr key={item.id}
											backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')} >
											<Td color={'#000'} alignCenter small>{i+1}</Td>
											<Td color={'#000'} alignCenter small>{item.cavalo}</Td>
											<Td color={'#000'} alignCenter small>{item.cavalo_descricao}</Td>
											<Td color={'#000'} alignCenter small>{item.carreta1}</Td>
											<Td color={'#000'} alignCenter small>{item.carreta2}</Td>
											<Td color={'#000'} alignCenter small title='Início'>
												<LabelAndInputDateResumido
													cols='12 6 4 4'
													fontSize={11}
													marginBottom={0}
													minWidth='100%'
													maxWidth={80}
													value={item.data_parada}
													onChange={value => {
														this.props.salvarGestaoVeiculo({
															...item,
															data_parada: value
														});
													}} />
											</Td>
											<Td color={'#000'} alignCenter small>{item.dias_parado}</Td>
											<Td color={'#000'} alignCenter small>{item.identificador}</Td>
											<Td color={'#000'} alignCenter small title='Local'>
												<div class='input-group input-group-sm'>
													<input type='text' class='form-control' 
														value={this.state.veiculosParadosLocais.filter(regAux => regAux.id == item.id)[0] ? this.state.veiculosParadosLocais.filter(regAux => regAux.id == item.id)[0].valor : ''}
														onChange={data => {
															
															let veiculosParadosLocais = this.state.veiculosParadosLocais.map(regAux => ({ ...regAux })).filter(regAux => regAux.id != item.id);

															veiculosParadosLocais.push({
																id: item.id,
																valor: data.target.value
															});
															this.setState({
																veiculosParadosLocais: veiculosParadosLocais
															});
														}}/>
													<span class='input-group-append'>
														<button type='button' class='btn btn-success btn-flat'
															onClick={() => {
																this.props.salvarGestaoVeiculo({
																	...item,
																	observacao_parada: this.state.veiculosParadosLocais.filter(regAux => regAux.id == item.id)[0] ? this.state.veiculosParadosLocais.filter(regAux => regAux.id == item.id)[0].valor : ''
																});
															}}>Ok</button>
													</span>
												</div>
											</Td>
											<Td color={'#000'} alignCenter small title='Operação'>
												<SelectResumido
													value={item.id_operacao}
													onChange={value => {
														this.props.salvarGestaoVeiculo({
															...item,
															id_operacao: value
														});
													}}
													options={this.props.listaOperacao} />
											</Td>
										</Tr>
									);
								} else {
									return (
										<Tr key={item.id}
											backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
											onClick={() => {
												let veiculosParadosLocais = this.state.veiculosParadosLocais.map(regAux => ({ ...regAux })).filter(regAux => regAux.id != item.id);

												veiculosParadosLocais.push({
													id: item.id,
													valor: item.observacao_parada
												});

												this.setState({
													linhaSelecionada: item.id,
													veiculosParadosLocais: veiculosParadosLocais
												});	
											}} >
											<Td color={'#000'} alignCenter small>{i+1}</Td>
											<Td color={'#000'} alignCenter small>{item.cavalo}</Td>
											<Td color={'#000'} alignCenter small>{item.cavalo_descricao}</Td>
											<Td color={'#000'} alignCenter small>{item.carreta1}</Td>
											<Td color={'#000'} alignCenter small>{item.carreta2}</Td>
											<Td color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_parada)}</Td>
											<Td color={'#000'} alignCenter small>{item.dias_parado}</Td>
											<Td color={'#000'} alignCenter small>{item.identificador}</Td>
											<Td color={'#000'} alignCenter small>{item.observacao_parada}</Td>
											<Td color={'#000'} alignCenter small>{item.nome_operacao}</Td>
										</Tr>
									);}
							})}
							{/*!readOnly &&
							<Tr backgroundColor={'#f5f5f5'} >
								<Td color={'#000'} alignCenter small bold>+</Td>
								<Td color={'#000'} alignCenter small title='Cavalo'>
									<ReactSelect
										isClearable={false}
										isSearchable={true}
										value={this.state.cavaloSelect}
										onChange={item => {
											this.props.salvarGestaoVeiculo({
												data_gestao: this.props.formularioValues.data_gestao,
												id_grupo: grupo.id,
												cavalo: item.value,
												carreta1: null,
												carreta2: null,
												id_motorista: null,
												id_operacao: null,
												data_parada: this.props.formularioValues.data_gestao
											});
											this.setState({
												cavaloSelect: 0
											})
										}}
										options={this.props.listaCavalo.map(opt => ({ value: opt.id, label: opt.valor }))}
										menuPortalTarget={document.body}
										styles={{
											menuPortal: base => ({ ...base, zIndex: 9999 }),
										}} />
								</Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
							</Tr>*/}
						</TBody>
					</Table>
				</div>
			</ContentCard>
		);
	}
	
	montarGrupoVeiculoNaoAlocado(grupo, posicao, listaGestaoVeiculo, readOnly) {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		if (this.getOrdenacao(grupo.id, 'cavalo')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'cavalo', a.cavalo, b.cavalo));
		} else if (this.getOrdenacao(grupo.id, 'modelo')) {
			listaGestaoVeiculo.sort((a, b) => this.ordenar(grupo.id, 'modelo', a.cavalo_descricao, b.cavalo_descricao));
		}

		return (
			<ContentCard style={{ marginTop: 8 }} colapsedCard={!this.state.gruposExpandidos.includes(grupo.id)}>
				<ContentCardHeader style={{ paddingBottom: 8 }}>
					<h3 class='card-title' style={{ marginTop: 6 }}>{posicao} - {grupo.valor}</h3>
					<div class='card-tools' style={{ display: 'flex', alignItems: 'center' }}>
						<span title='Registros' 
							class='badge badge-dark'
							style={{
								paddingLeft: 8,
								paddingTop: 4,
								paddingRight: 8,
								paddingBottom: 4,
								fontSize: 14,
								fontWeight: 'normal'
							}}>{listaGestaoVeiculo.length}</span>
						<button type='button'
							class='btn btn-secondary btn-sm'
							data-card-widget='collapse'
							onClick={() => {
								this.setGrupoExpandido(grupo.id);
							}}>
							<i class={!this.state.gruposExpandidos.includes(grupo.id) ? 'fas fa-chevron-down' : 'fas fa-chevron-up'}></i>
						</button>
						<ExcelFile
							filename={`${posicao} - ${grupo.valor}`}
							element={
								<button type='button' class='btn btn-success btn-sm' title='Exportar'>
									<i class='fas fa-file-excel'></i>
								</button>
							}>
							<ExcelSheet data={listaGestaoVeiculo.map((item, i) => ({
								...item,
								ordem: i+1
							}))} name={`${posicao} - ${grupo.valor}`}>
								<ExcelColumn label='Ordem' value='ordem' />
								<ExcelColumn label='Cavalo' value='cavalo' />
								<ExcelColumn label='Modelo' value='cavalo_descricao' />
							</ExcelSheet>
						</ExcelFile>
					</div>
				</ContentCardHeader>
				<div className={`card-body gestao-vm-box ${this.state.gruposExpandidos.includes(grupo.id) ? 'open': ''}`} style={{ paddingRight: 0, paddingBottom: 0, paddingLeft: 0, paddingTop: 0 }}>
					<Table responsive border striped>
						<THead>
							<Tr backgroundColor={'#1F3066'} color={'#ffffff'}>
								<Th width={1} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter></Th>
								<Th width={1000} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'cavalo')}>Cavalo {this.getIconeOrdenacao(grupo.id, 'cavalo')}</Th>
								<Th width={1000} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'modelo')}>Modelo {this.getIconeOrdenacao(grupo.id, 'modelo')}</Th>
							</Tr>
						</THead>
						<TBody>
							{listaGestaoVeiculo.map((item, i) => {
								return (
									<Tr key={item.id}
										backgroundColor={this.state.linhaSelecionadaVeiculoNaoAlocado == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
										onClick={() => {
											this.setState({ 
												linhaSelecionadaVeiculoNaoAlocado: item.id,
											});	
										}} >
										<Td color={'#000'} alignCenter small>{i+1}</Td>
										<Td color={'#000'} alignCenter small>{item.cavalo}</Td>
										<Td color={'#000'} alignCenter small>{item.cavalo_descricao}</Td>
									</Tr>
								);
							})}							
						</TBody>
					</Table>
				</div>
			</ContentCard>
		);
	}

	montarGrupoMotorista(grupo, posicao, listaGestaoMotorista, readOnly) {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		if (this.getOrdenacao(grupo.id, 'motorista')) {
			listaGestaoMotorista.sort((a, b) => this.ordenar(grupo.id, 'motorista', a.valor, b.valor));
		} else if (this.getOrdenacao(grupo.id, 'comentario')) {
			listaGestaoMotorista.sort((a, b) => this.ordenar(grupo.id, 'comentario', 
				this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == a.id).length,
				this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == b.id).length
			));
		} else if (this.getOrdenacao(grupo.id, 'documento_vencimento')) {
			listaGestaoMotorista.sort((a, b) => this.ordenar(grupo.id, 'documento_vencimento',
				this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == a.id && vencimento.alerta).length,
				this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == b.id && vencimento.alerta).length
			));
		} else if (this.getOrdenacao(grupo.id, 'motivo')) {
			listaGestaoMotorista.sort((a, b) => this.ordenar(grupo.id, 'motivo', a.nome_motivo, b.nome_motivo));
		} else if (this.getOrdenacao(grupo.id, 'inicio')) {
			listaGestaoMotorista.sort((a, b) => this.ordenar(grupo.id, 'inicio', a.data_inicio, b.data_inicio));
		} else if (this.getOrdenacao(grupo.id, 'termino')) {
			listaGestaoMotorista.sort((a, b) => this.ordenar(grupo.id, 'termino', a.data_termino, b.data_termino));
		} else if (this.getOrdenacao(grupo.id, 'tempo_decorrido')) {
			listaGestaoMotorista.sort((a, b) => this.ordenar(grupo.id, 'tempo_decorrido', a.dias_decorrido, b.dias_decorrido));
		} else if (this.getOrdenacao(grupo.id, 'operacao')) {
			listaGestaoMotorista.sort((a, b) => this.ordenar(grupo.id, 'operacao', a.nome_operacao, b.nome_operacao));
		}

		return (
			<ContentCard style={{ marginTop: 8 }} colapsedCard={!this.state.gruposExpandidos.includes(grupo.id)}>
				<ContentCardHeader style={{ paddingBottom: 8 }}>
					<h3 class='card-title' style={{ marginTop: 6 }}>{posicao} - {grupo.valor}</h3>
					<div class='card-tools' style={{ display: 'flex', alignItems: 'center' }}>
						<span title='Registros' 
							class='badge badge-dark'
							style={{
								paddingLeft: 8,
								paddingTop: 4,
								paddingRight: 8,
								paddingBottom: 4,
								fontSize: 14,
								fontWeight: 'normal'
							}}>{listaGestaoMotorista.length}</span>

						<button type='button'
							class='btn btn-secondary btn-sm'
							data-card-widget='collapse'
							onClick={() => {
								this.setGrupoExpandido(grupo.id);
							}}>
							<i class={!this.state.gruposExpandidos.includes(grupo.id) ? 'fas fa-chevron-down' : 'fas fa-chevron-up'}></i>
						</button>
						<ExcelFile
							filename={`${posicao} - ${grupo.valor}`}
							element={
								<button type='button' class='btn btn-success btn-sm' title='Exportar'>
									<i class='fas fa-file-excel'></i>
								</button>
							}>
							<ExcelSheet data={listaGestaoMotorista.map((item, i) => ({
								...item,
								ordem: i+1,
								nome_motorista: item.valor,
								data_inicio: DateFormat.formatarDataSqlParaTela(item.data_inicio),
								data_termino: DateFormat.formatarDataSqlParaTela(item.data_termino),
								comentarios: this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == item.id_motorista).length,
								alerta_documento: this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == item.id_motorista && vencimento.alerta).length > 0 ? 'SIM' : 'NÃO'
							}))} name={`${posicao} - ${grupo.valor}`}>
								<ExcelColumn label='Ordem' value='ordem' />
								<ExcelColumn label='Motorista' value='nome_motorista' />
								<ExcelColumn label='Comentário' value='comentarios' />
								<ExcelColumn label='Documentos e Vencimentos' value='alerta_vencimento' />
								<ExcelColumn label='Motivo' value='nome_motivo' />
								<ExcelColumn label='Início' value='data_inicio' />
								<ExcelColumn label='Término' value='data_termino' />
								<ExcelColumn label='Tempo Decorrido' value='dias_decorrido' />
								<ExcelColumn label='Operação' value='nome_operacao' />
							</ExcelSheet>
						</ExcelFile>
					</div>
				</ContentCardHeader>
				<div className={`card-body gestao-vm-box ${this.state.gruposExpandidos.includes(grupo.id) ? 'open': ''}`} style={{ paddingRight: 0, paddingBottom: 0, paddingLeft: 0, paddingTop: 0 }}>
					<Table responsive border striped>
						<THead>
							<Tr backgroundColor={'#1F3066'} color={'#ffffff'}>
								<Th width={1} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter></Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'motorista')}>Motorista {this.getIconeOrdenacao(grupo.id, 'motorista')}</Th>
								<Th width={1} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Comentário'
									onClick={() => this.setOrdenacao(grupo.id, 'comentario')}>
									<i class='fas fa-comments'></i> {this.getIconeOrdenacao(grupo.id, 'comentario')}
								</Th>
								<Th width={1} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Documentos e Vencimentos'
									onClick={() => this.setOrdenacao(grupo.id, 'documento_vencimento')}>
									<i class='fas fa-calendar-alt'></i> {this.getIconeOrdenacao(grupo.id, 'documento_vencimento')}
								</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'motivo')}>Motivo {this.getIconeOrdenacao(grupo.id, 'motivo')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'inicio')}>Início {this.getIconeOrdenacao(grupo.id, 'inicio')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'termino')}>Término {this.getIconeOrdenacao(grupo.id, 'termino')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'tempo_decorrido')}>Tempo Decorrido {this.getIconeOrdenacao(grupo.id, 'tempo_decorrido')}</Th>
								<Th width={100} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'operacao')}>Operação {this.getIconeOrdenacao(grupo.id, 'operacao')}</Th>
							</Tr>
						</THead>
						<TBody>
							{listaGestaoMotorista.map((item, i) => {
								if (this.state.linhaMotoristaSelecionada == item.id && !readOnly) {
									return (
										<Tr key={item.id}
											backgroundColor={this.state.linhaMotoristaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')} >
											<Td color={'#000'} alignCenter small>{i+1}</Td>
											<Td color={'#000'} alignCenter small title='Motorista'>
												<SelectResumido
													value={item.id_motorista}
													onChange={value => {
														this.props.salvarGestaoMotorista({
															...item,
															id_motorista: value
														});
													}}
													options={this.props.listaMotorista} />
											</Td>
											<Td color={'#000'} alignCenter small title='Comentário'>
												<button type='button' 
													class='btn btn-secondary'
													style={{
														width: 24,
														height: 24,
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														padding: 0
													}}
													disabled={!item.id_motorista}
													onClick={() => {
														if (item.id_motorista) {
															this.setState({
																registroComentario: {
																	id_motorista: item.id_motorista,
																	nome_motorista: item.nome_motorista
																}
															});
														}
													}}>{this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == item.id_motorista).length}</button>
											</Td>
											<Td color={'#000'} alignCenter small title='Documentos e Vencimentos'>
												<button type='button' 
													class='btn btn-secondary'
													style={{
														width: 24,
														height: 24,
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														padding: 0,
														backgroundColor: this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == item.id_motorista && vencimento.alerta).length > 0 ? '#ff2a00' : null
													}}
													disabled={!item.id_motorista}
													onClick={() => {
														if (item.id_motorista) {
															this.setState({
																registroVencimentoMotorista: {
																	id_motorista: item.id_motorista,
																	nome_motorista: item.nome_motorista,
																	grupo: grupo
																}
															});
														}
													}}>
													{this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == item.id_motorista && vencimento.alerta).length > 0 ? (
														<i class='fas fa-exclamation-triangle'></i>
													) : (
														<i class='fas fa-check'></i>
													)}
												</button>
											</Td>
											<Td color={'#000'} alignCenter small title='Motivo'>
												<SelectResumido
													value={item.id_motivo}
													onChange={value => {
														this.props.salvarGestaoMotorista({
															...item,
															id_motivo: value
														});
													}}
													options={this.props.listaMotivo} />
											</Td>
											<Td color={'#000'} alignCenter small title='Início'>
												<LabelAndInputDate
													cols='12 6 4 4'
													fontSize={11}
													marginBottom={0}
													value={item.data_inicio}
													onChange={value => {
														this.props.salvarGestaoMotorista({
															...item,
															data_inicio: value
														});
													}} />
											</Td>
											<Td color={'#000'} alignCenter small title='Término'>
												<LabelAndInputDate
													cols='12 6 4 4'
													fontSize={11}
													marginBottom={0}
													value={item.data_termino}
													onChange={value => {
														this.props.salvarGestaoMotorista({
															...item,
															data_termino: value
														});
													}} />
											</Td>
											<Td color={'#000'} alignCenter small>{item.dias_decorrido}</Td>
											<Td color={'#000'} alignCenter small title='Operação'>
												<SelectResumido
													value={item.id_operacao}
													onChange={value => {
														this.props.salvarGestaoMotorista({
															...item,
															id_operacao: value
														});
													}}
													options={this.props.listaOperacao} />
											</Td>
										</Tr>
									);
								} else {
									return (
										<Tr key={item.id}
											backgroundColor={this.state.linhaMotoristaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
											onClick={() => {
												this.setState({
													linhaMotoristaSelecionada: item.id
												});	
											}} >
											<Td color={'#000'} alignCenter small>{i+1}</Td>
											<Td color={'#000'} alignCenter small>{item.nome_motorista}</Td>
											<Td color={'#000'} alignCenter small title='Comentário'>
												<button type='button' 
													class='btn btn-secondary'
													disabled={!item.id_motorista}
													onClick={() => {
														if (item.id_motorista) {
															this.setState({
																registroComentario: {
																	id_motorista: item.id_motorista,
																	nome_motorista: item.nome_motorista
																}
															});
														}
													}}>{this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == item.id_motorista).length}</button>
											</Td>
											<Td color={'#000'} alignCenter small title='Documentos e Vencimentos'>
												<button type='button' 
													class='btn btn-secondary'
													style={{
														width: 24,
														height: 24,
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'center',
														padding: 0,
														backgroundColor: this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == item.id_motorista && vencimento.alerta).length > 0 ? '#ff2a00' : null
													}}
													disabled={!item.id_motorista}
													onClick={() => {
														if (item.id_motorista) {
															this.setState({
																registroVencimentoMotorista: {
																	id_motorista: item.id_motorista,
																	nome_motorista: item.nome_motorista,
																	grupo: grupo
																}
															});
														}
													}}>
													{this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == item.id_motorista && vencimento.alerta).length > 0 ? (
														<i class='fas fa-exclamation-triangle'></i>
													) : (
														<i class='fas fa-check'></i>
													)}
												</button>
											</Td>
											<Td color={'#000'} alignCenter small>{item.nome_motivo}</Td>
											<Td color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_inicio)}</Td>
											<Td color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_termino)}</Td>
											<Td color={'#000'} alignCenter small>{item.dias_decorrido}</Td>
											<Td color={'#000'} alignCenter small>{item.nome_operacao}</Td>
										</Tr>
									);}
							})}
							{!readOnly &&
							<Tr backgroundColor={'#f5f5f5'} >
								<Td color={'#000'} alignCenter small bold>+</Td>
								<Td color={'#000'} alignCenter small>
									<ReactSelect
										isClearable={false}
										isSearchable={true}
										value={this.state.motoristaSelect}
										onChange={item => {
											this.props.salvarGestaoMotorista({
												data_gestao: this.props.formularioValues.data_gestao,
												id_grupo: grupo.id,
												id_motorista: item.value,
												id_motivo: null,
												data_inicio: null,
												data_termino: null,
												id_operacao: null
											});
											this.setState({
												motoristaSelect: 0
											})
										}}
										options={this.props.listaMotorista.map(opt => ({ value: opt.id, label: opt.valor }))}
										menuPortalTarget={document.body}
										styles={{
											menuPortal: base => ({ ...base, zIndex: 9999 }),
										}} />
								</Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
								<Td color={'#000'} alignCenter small></Td>
							</Tr>}
						</TBody>
					</Table>
				</div>
			</ContentCard>
		);
	}

	montarGrupoMotoristaNaoAlocado(grupo, posicao, listaMotorista, readOnly) {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		if (this.getOrdenacao(grupo.id, 'motorista')) {
			listaMotorista.sort((a, b) => this.ordenar(grupo.id, 'motorista', a.valor, b.valor));
		} else if (this.getOrdenacao(grupo.id, 'comentario')) {
			listaMotorista.sort((a, b) => this.ordenar(grupo.id, 'comentario', 
				this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == a.id).length,
				this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == b.id).length
			));
		} else if (this.getOrdenacao(grupo.id, 'documento_vencimento')) {
			listaMotorista.sort((a, b) => this.ordenar(grupo.id, 'documento_vencimento',
				this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == a.id && vencimento.alerta).length,
				this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == b.id && vencimento.alerta).length
			));
		}

		return (
			<ContentCard style={{ marginTop: 8 }} colapsedCard={!this.state.gruposExpandidos.includes(grupo.id)}>
				<ContentCardHeader style={{ paddingBottom: 8 }}>
					<h3 class='card-title' style={{ marginTop: 6 }}>{posicao} - {grupo.valor}</h3>
					<div class='card-tools' style={{ display: 'flex', alignItems: 'center' }}>
						<span title='Registros' 
							class='badge badge-dark'
							style={{
								paddingLeft: 8,
								paddingTop: 4,
								paddingRight: 8,
								paddingBottom: 4,
								fontSize: 14,
								fontWeight: 'normal'
							}}>{listaMotorista.length}</span>

						<button type='button'
							class='btn btn-secondary btn-sm'
							data-card-widget='collapse'
							onClick={() => {
								this.setGrupoExpandido(grupo.id);
							}}>
							<i class={!this.state.gruposExpandidos.includes(grupo.id) ? 'fas fa-chevron-down' : 'fas fa-chevron-up'}></i>
						</button>
						<ExcelFile
							filename={`${posicao} - ${grupo.valor}`}
							element={
								<button type='button' class='btn btn-success btn-sm' title='Exportar'>
									<i class='fas fa-file-excel'></i>
								</button>
							}>
							<ExcelSheet data={listaMotorista.map((item, i) => ({
								...item,
								ordem: i+1,
								nome_motorista: item.valor,
								comentarios: this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == item.id_motorista).length,
								alerta_documento: this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == item.id_motorista && vencimento.alerta).length > 0 ? 'SIM' : 'NÃO'
							}))} name={`${posicao} - ${grupo.valor}`}>
								<ExcelColumn label='Ordem' value='ordem' />
								<ExcelColumn label='Motorista' value='nome_motorista' />
								<ExcelColumn label='Comentário' value='comentarios' />
								<ExcelColumn label='Documentos e Vencimentos' value='alerta_vencimento' />
							</ExcelSheet>
						</ExcelFile>
					</div>
				</ContentCardHeader>
				<div className={`card-body gestao-vm-box ${this.state.gruposExpandidos.includes(grupo.id) ? 'open': ''}`} style={{ paddingRight: 0, paddingBottom: 0, paddingLeft: 0, paddingTop: 0 }}>
					<Table responsive border striped>
						<THead>
							<Tr backgroundColor={'#1F3066'} color={'#ffffff'}>
								<Th width={1} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter></Th>
								<Th width={1000} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter
									onClick={() => this.setOrdenacao(grupo.id, 'motorista')}>Motorista {this.getIconeOrdenacao(grupo.id, 'motorista')}</Th>
								<Th width={1} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Comentário'
									onClick={() => this.setOrdenacao(grupo.id, 'comentario')}>
									<i class='fas fa-comments'></i> {this.getIconeOrdenacao(grupo.id, 'comentario')}
								</Th>
								<Th width={1} paddingTop={2} paddingBottom={2} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Documentos e Vencimentos'
									onClick={() => this.setOrdenacao(grupo.id, 'documento_vencimento')}>
									<i class='fas fa-calendar-alt'></i> {this.getIconeOrdenacao(grupo.id, 'documento_vencimento')}
								</Th>
							</Tr>
						</THead>
						<TBody>
							{listaMotorista.map((item, i) => {							
								return (
									<Tr key={item.id}
										backgroundColor={this.state.linhaSelecionadaMotoristaNaoAlocado == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
										onClick={() => {
											this.setState({
												linhaSelecionadaMotoristaNaoAlocado: item.id,
											});	
										}} >
										<Td color={'#000'} alignCenter small>{i+1}</Td>
										<Td color={'#000'} alignCenter small>{item.valor}</Td>
										<Td color={'#000'} alignCenter small title='Comentário'>
											<button type='button' 
												class='btn btn-secondary'
												style={{
													width: 24,
													height: 24,
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													padding: 0
												}}
												disabled={!item.id}
												onClick={() => {
													if (item.id) {
														this.setState({
															registroComentario: {
																id_motorista: item.id,
																nome_motorista: item.valor
															}
														});
													}
												}}>{this.props.listaGestaoComentario.filter(comentario => comentario.id_motorista == item.id).length}</button>
										</Td>
										<Td color={'#000'} alignCenter small title='Documentos e Vencimentos'>
											<button type='button' 
												class='btn btn-secondary'
												style={{
													width: 24,
													height: 24,
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													padding: 0,
													backgroundColor: this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == item.id && vencimento.alerta).length > 0 ? '#ff2a00' : null
												}}
												onClick={() => {
													if (item.id_motorista) {
														this.setState({
															registroVencimentoMotorista: {
																id_motorista: item.id,
																nome_motorista: item.valor,
																grupo: grupo
															}
														});
													}
												}}>
												{this.props.listaMotoristaVencimento.filter(vencimento => vencimento.id_motorista == item.id && vencimento.alerta).length > 0 ? (
													<i class='fas fa-exclamation-triangle'></i>
												) : (
													<i class='fas fa-check'></i>
												)}
											</button>
										</Td>
									</Tr>
								);
							})}							
						</TBody>
					</Table>
				</div>
			</ContentCard>
		);
	}

	montarGrupo(grupo, posicao, readOnly) {

		return (
			<ContentCard style={{ marginTop: 8 }} colapsedCard={!this.state.gruposExpandidos.includes(grupo.id)}>
				<ContentCardHeader style={{ paddingBottom: 8 }}>
					<h3 class='card-title'>{posicao} - {grupo.valor}</h3>
				</ContentCardHeader>
				<div className='card-body' style={{ paddingRight: 0, paddingBottom: 0, paddingLeft: 0, paddingTop: 0 }}>
					
				</div>
			</ContentCard>
		);
	}

	modalComentario() {

		if (!this.state.registroComentario) {
			return;
		}

		return (
			<>
				<div className="modal-backdrop fade show" />
				<div class='modal fade show'
					id='modal-xl'
					style={{ display: 'block' }}
					aria-modal='true'>
					<div class='modal-dialog modal-xl'>
						<div class='modal-content'>
							<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
								<h4 class='modal-title'>Comentários - {this.state.registroComentario.nome_motorista}</h4>
								<button type='button' class='close custom-close' data-dismiss='modal' aria-label='Close'
									onClick={() => this.setState({ registroComentario: null })}>
									<span aria-hidden='true' style={{ color: '#fff', fontSize: 32, marginRight: 4 }}>×</span>
								</button>
							</div>
							<div class='modal-body' style={{ height: window.innerHeight * 0.8, overflowY: 'scroll', padding: 2 }}>
								<GestaoVMComentario
									data_gestao={this.props.formularioValues.data_gestao}
									id_motorista={this.state.registroComentario.id_motorista} />
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}

	modalVencimentoMotorista() {

		if (!this.state.registroVencimentoMotorista) {
			return;
		}

		const registroMotorista = this.props.listaMotoristaVencimento.filter(item => item.id_motorista == this.state.registroVencimentoMotorista.id_motorista)[0];
		const grupo = this.props.listaGrupo.filter(item => item.id == this.state.registroVencimentoMotorista.grupo.id)[0] || {};
		const lista = registroMotorista ? registroMotorista.vencimentos : [];

		return (
			<>
				<div className="modal-backdrop fade show" />
				<div class='modal fade show'
					id='modal-xl'
					style={{ display: 'block' }}
					aria-modal='true'>
					<div class='modal-dialog modal-xl' style={{ backgroundColor: '#1F3066' }}>
						<div class='modal-content' style={{ backgroundColor: '#1F3066' }}>
							<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
								<h4 class='modal-title'>Vencimentos - {this.state.registroVencimentoMotorista.nome_motorista}</h4>
								<button type='button' class='close custom-close' data-dismiss='modal' aria-label='Close'
									onClick={() => this.setState({ registroVencimentoMotorista: null })}>
									<span aria-hidden='true' style={{ color: '#fff', fontSize: 32, marginRight: 4 }}>×</span>
								</button>
							</div>
							<div class='modal-body' style={{ height: window.innerHeight * 0.8, overflowY: 'scroll', padding: 2 }}>
								<ContentCard style={{ height: '100%', backgroundColor: '#1F3066' }}>
									<ContentCardBody style={{ paddingTop: 0, backgroundColor: '#1F3066' }}>
										
										{/*
										controla_validade_rg
										controla_validade_cnh
										controla_validade_mopp
										controla_validade_aso
										*/}
										<Row alignCenter>
											<a class={`btn btn-app ${grupo.controla_validade_rg ? 'bg-success' : ''}`}
												onClick={() => {
													this.props.alterarValidaVencimentos({
														...grupo,
														controla_validade_rg: !grupo.controla_validade_rg
													}, () => {
														this.props.getListaMotoristaVencimento(this.props.formularioValues.data_gestao);
													});
												}}>
												<i class={grupo.controla_validade_rg ? 'fas fa-calendar-check' : 'fas fa-calendar-times'}></i> RG
											</a>
											<a class={`btn btn-app ${grupo.controla_validade_cnh ? 'bg-success' : ''}`}
												onClick={() => {
													this.props.alterarValidaVencimentos({
														...grupo,
														controla_validade_cnh: !grupo.controla_validade_cnh
													}, () => {
														this.props.getListaMotoristaVencimento(this.props.formularioValues.data_gestao);
													});
												}}>
												<i class={grupo.controla_validade_cnh ? 'fas fa-calendar-check' : 'fas fa-calendar-times'}></i> CNH
											</a>
											<a class={`btn btn-app ${grupo.controla_validade_mopp ? 'bg-success' : ''}`}
												onClick={() => {
													this.props.alterarValidaVencimentos({
														...grupo,
														controla_validade_mopp: !grupo.controla_validade_mopp
													}, () => {
														this.props.getListaMotoristaVencimento(this.props.formularioValues.data_gestao);
													});
												}}>
												<i class={grupo.controla_validade_mopp ? 'fas fa-calendar-check' : 'fas fa-calendar-times'}></i> MOPP
											</a>
											<a class={`btn btn-app ${grupo.controla_validade_aso ? 'bg-success' : ''}`}
												onClick={() => {
													this.props.alterarValidaVencimentos({
														...grupo,
														controla_validade_aso: !grupo.controla_validade_aso
													}, () => {
														this.props.getListaMotoristaVencimento(this.props.formularioValues.data_gestao);
													});
												}}>
												<i class={grupo.controla_validade_aso ? 'fas fa-calendar-check' : 'fas fa-calendar-times'}></i> ASO
											</a>
										</Row>

										<div 
											style={{ 
												backgroundColor: '#1F3066',
												marginLeft: -8,
												marginRight: -8,
												marginBottom: -8,
												paddingTop: 1,
												paddingLeft: 8,
												paddingRight: 8,
												paddingBottom: 8
											}}>
											<Table responsive border striped alturaFixa
												maxHeight={'100%'}>
												<THead>
													<Tr backgroundColor={'#1F3066'}
														color={'#ffffff'}
														height={47}>
														<Th paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Documento</Th>
														<Th paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Vencimento</Th>
														<Th paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Status</Th>
													</Tr>
												</THead>
												<TBody>
													{lista.map((item, i) => (
														<Tr key={item.id}
															backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
															onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
															<Td color={'#000'} alignCenter small>{item.documento}</Td>															
															<Td color={'#000'} alignCenter small>{item.data_vencimento ? DateFormat.formatarDataSqlParaTela(item.data_vencimento) : 'Não Informado'}</Td>
															<Td 
																color={
																	!item.data_vencimento || item.dias_vencimento > 7 ? null : '#ff2a00'
																} 
																alignCenter small>{
																item.data_vencimento ? (
																	item.dias_vencimento > 30 ? 'Vigente' : (
																		item.dias_vencimento >= 1 ? `Vence em ${item.dias_vencimento} dias` : (
																			item.dias_vencimento == 1 ? 'Vence amanhã' : 'Vencido'
																		)
																	)
																) : 'Sem vencimento'
															}</Td>
														</Tr>
													))}
												</TBody>
											</Table>
										</div>
									</ContentCardBody>
								</ContentCard>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}

}

GestaoVMForm = reduxForm({ form: 'gestaoVMGrupoForm', destroyOnUnmount: false })(GestaoVMForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('gestaoVMForm')(state),
	registro: state.gestaoVM.registro,
	filtro: state.gestaoVM.filtro,
	listaGestaoVeiculo: state.gestaoVM.listaGestaoVeiculo,
	listaGestaoMotorista: state.gestaoVM.listaGestaoMotorista,
	listaMotorista: state.gestaoVM.listaMotorista.filter(item => item.contrato_ativo),
	listaCavalo: state.gestaoVM.listaCavalo,
	listaCarreta: state.gestaoVM.listaCarreta,
	listaGrupo: state.gestaoVMGrupo.listaSelect,
	listaOperacao: state.gestaoVMOperacao.listaSelect,
	listaMotivo: state.gestaoVMMotivo.listaSelect,
	listaComentarioTipo: state.gestaoVMComentarioTipo.listaSelect,
	listaGestaoComentario: state.gestaoVMComentario.lista,
	listaMotoristaVencimento: state.gestaoVM.listaMotoristaVencimento,
	listaMotoristaGrupo: state.motoristaGrupo.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, setFiltro, finalizar, 
	getListaMotorista, getListaPlaca,
	getListaGestaoMotorista, salvarGestaoMotorista,
	getListaGestaoVeiculo, salvarGestaoVeiculo,
	getListaGestaoComentarioTipo, getListaGestaoComentario, 
	alterrarMotoristaVencimento, getListaMotoristaVencimento,
	buscarPermissao, getListaGrupo, alterarValidaVencimentos,
	getListaMotoristaGrupo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(GestaoVMForm);